export default __webpack_public_path__ + "static/media/010-heart rate.af9dab8f.svg";